import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem 0',
    margin: '4rem 1.6rem 0',
    gap: '1.6rem',
    backgroundColor: $theme.colors.white,
    borderTop: `1px solid #EAECF0`,
    borderBottom: `1px solid #EAECF0`
}))

export const EmailAddress = styled('div', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    fontWeight: 700
}))

export const CurrentEmailAddress = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 300
}))

export const Email = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    marginTop: '4px',
    fontWeight: 700
}))

export const ButtonWrapper = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    marginTop: '2rem',
    padding: '0 1.6rem'
}))

export const RightIcon = styled('i', ({ $theme }) => ({
    fontSize: '2.4rem',
    color: $theme.colors.primary,
    cursor: 'pointer'
}))

export const DeleteButton = styled('button', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    backgroundColor: $theme.colors.white,
    textAlign: 'center',
    padding: '1.3rem 0',
    borderRadius: '5rem',
    border: `2px solid #FE2C3E`,
    width: '100%',
    color: '#FE2C3E',
    display: 'flex',
    justifyContent: 'center',
    gap: '1.6rem',
    alignItems: 'center',
    fontWeight: 700,
    cursor: 'pointer'
}))
